interface Props {
  socPct: number | null
  capacityKwh: number
  energyRemainingKwh: number | null
}

export function SoCIndicator({ socPct, capacityKwh, energyRemainingKwh }: Props) {
  const displayPct = socPct !== null ? Math.round(socPct) : null
  const barWidth =
    displayPct !== null ? `${Math.max(0, Math.min(100, displayPct))}%` : '0%'

  return (
    <div className="soc-indicator">
      <div className="soc-label">Battery State of Charge</div>
      <div className="soc-value">
        {displayPct !== null ? (
          <>
            <span className="soc-percent">{displayPct}</span>
            <span className="soc-unit">%</span>
          </>
        ) : (
          <span className="soc-unavailable">—</span>
        )}
      </div>
      <div
        className="soc-bar"
        role="progressbar"
        aria-valuenow={displayPct ?? 0}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Battery state of charge"
      >
        <div className="soc-bar-fill" style={{ width: barWidth }} />
      </div>
      <div className="soc-footer">
        {energyRemainingKwh !== null ? (
          <>
            <strong>{energyRemainingKwh.toFixed(1)} kWh</strong> remaining of{' '}
            {capacityKwh.toFixed(1)} kWh capacity
          </>
        ) : (
          <>{capacityKwh.toFixed(1)} kWh capacity</>
        )}
      </div>
    </div>
  )
}
